import { render, staticRenderFns } from "./kompensasi.vue?vue&type=template&id=a0830532&"
import script from "./kompensasi.vue?vue&type=script&lang=js&"
export * from "./kompensasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports